import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [branch, setBranch] = useState(null);

  const fetchMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setBranch(data.branch);
    } catch (error) {
      console.error("Auth check failed:", error);
      setUser(false);
      setBranch(null);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("finexec_token")) fetchMe();
    else setUser(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("finexec_token", data.token);
    await fetchMe();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      console.error("Logout request failed:", error);
    }
    localStorage.removeItem("finexec_token");
    setUser(false);
    setBranch(null);
  };

  return (
    <AuthContext.Provider value={{ user, branch, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
